import apiService from '@/services/apiService';

const actions = {
  getPPOBProductWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('ppob/product/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllPPOBProductGroupByProviderAndType({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get(`ppob/product/find-group-by-provider-and-type`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllPPOBProductGroupByProviderAndTypeAndBillType({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get(`ppob/product/find-group-by-provider-and-type-and-bill-type`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPPOBProduct({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`ppob/product/find-by-id/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPPOBProductByProviderAndType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`ppob/product/find-by-provider-id/${payload.provider_id}/type/${payload.product_type}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPPOBProductByProviderAndTypeAndBillType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`ppob/product/find-by-provider-id/${payload.provider_id}/type/${payload.product_type}/bill-type/${payload.bill_type}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeOrderByType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`ppob/product/${payload.id}/change-order-by-type`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeOrderByTypeAndBillType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`ppob/product/${payload.id}/change-order-by-type-and-bill-type`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`ppob/product/${payload.id}/update-status`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postPPOBProduct({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('ppob/product', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putPPOBProduct({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`ppob/product/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postCalculateSpecial({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('ppob/product/calculate-special-rate', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default actions;